import React, { useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import { useTranslation } from 'react-i18next';

interface INameSubCategoryInput {
	changeNameOfSubCategory: (value: string) => void;
}

const NameSubCategoryInput: React.FC<INameSubCategoryInput> = ({ changeNameOfSubCategory }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterSubcategoryName') }], [t]);

	return (
		<FormInput
			testId="NameSubCategoryInput"
			name="nameOfSubCategory"
			label="nameSubcategoryLabel"
			onChange={changeNameOfSubCategory}
			validationRules={validationRules}
			maxLength={100}
		/>
	);
};

export default React.memo(NameSubCategoryInput);
